module.exports = __webpack_public_path__ + "media/images/recruit/common/og-image-3176ba4db226b955d98f61a900c2996f.png";